import { DefaultSecondaryButton } from '@frontend/components/common';
import React from 'react';
import { IconType } from 'react-icons';

export interface Button {
    label: React.ReactNode;
    icon?: string | IconType;
    onClick: () => void;
    disabled?: boolean;
    hide?: boolean;
}

export interface ButtonGroupProps {
    buttons: Button[];
    className?: string;
}

export const ButtonGroup = (props: ButtonGroupProps) => {
    return (
        <div className={props.className || 'flex flex-wrap gap-2'}>
            {props.buttons.map((button) => {
                if (button.hide) return null;
                return (
                    <DefaultSecondaryButton
                        text={button.label}
                        onClick={button.onClick}
                        disabled={button.disabled}
                    />
                );
            })}
        </div>
    );
};
